import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Calculator, LayoutList, GitCompare, Tags, LogOut, Wallet } from "lucide-react";

/** Layout modul System HPP — mobile-first: header ringkas + bottom nav di HP, nav horizontal di desktop. */
export default function HppLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isSA = user?.role === "super_admin";
  const canKeuangan = (user?.module_access || ["keuangan"]).includes("keuangan");
  const items = [
    { to: "/hpp", label: "Simulasi", icon: LayoutList, end: true, testid: "hpp-nav-list" },
    { to: "/hpp/baru", label: "Kalkulator", icon: Calculator, testid: "hpp-nav-new" },
    { to: "/hpp/bandingkan", label: "Bandingkan", icon: GitCompare, testid: "hpp-nav-compare" },
    ...(isSA ? [{ to: "/hpp/kategori", label: "Kategori", icon: Tags, testid: "hpp-nav-kategori" }] : []),
  ];
  const switchKeuangan = () => { try { localStorage.setItem("khn_module", "keuangan"); } catch { /* ignore */ } nav("/"); };
  const doLogout = () => { logout(); nav("/login"); };
  return (
    <div className="min-h-screen bg-[var(--bg)] pb-20 md:pb-0">
      <header className="bg-[var(--sidebar)] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-14 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <Calculator size={20} className="text-emerald-400 shrink-0" />
            <div className="min-w-0">
              <div className="font-semibold tracking-tight text-sm md:text-base leading-tight">System HPP</div>
              <div className="text-[10px] md:text-[11px] text-slate-400 truncate">Business Feasibility & HPP Calculator</div>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}
                className={({ isActive }) => `px-3 py-2 rounded-sm text-sm inline-flex items-center gap-2 ${isActive ? "bg-white/10 text-white" : "text-slate-300 hover:text-white"}`}>
                <it.icon size={15} /> {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-1.5 shrink-0">
            {canKeuangan && (
              <button onClick={switchKeuangan} data-testid="hpp-switch-keuangan"
                className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-sm bg-white/10 hover:bg-white/20">
                <Wallet size={14} /> <span className="hidden sm:inline">Keuangan</span>
              </button>
            )}
            <button onClick={doLogout} data-testid="hpp-logout" title="Keluar"
              className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-sm bg-white/10 hover:bg-white/20">
              <LogOut size={14} /> <span className="hidden sm:inline">Keluar</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto"><Outlet /></main>
      {/* Bottom nav (mobile) */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end} data-testid={`${it.testid}-m`}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] ${isActive ? "text-[color:var(--brand)] font-semibold" : "text-slate-500"}`}>
            <it.icon size={20} /> {it.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
